export enum UomTypeEnum {
  Unit = 0,
  Case = 1,
  Pack = 2
}
